export default class Api {
  constructor(el, opt) {
    this.$el = $(el)
    this.defaults = {
      stripe: true, // 带斑马线的表格
      border: true, // 带边框的表格
      height: '0', // 固定表头,值越高,表格越矮,0取消
      highest: '0', // 流体高度,固定表头,0取消
      hover: true, // 行浮动效果

      anthor: 'body', // 滚动的锚点

      codeContent: {}, // code容器
      highlightCurrentRow: true, // 实现单选
      multable: true, // 实现多选
      cellNoWrap: true // 表格文字不换行
    }
    this.settings = Object.assign({}, this.defaults, opt)
    this._length = 0
    this._transColumn = {}
    this.checkedRow = {
    }
  }

  loadData(args) {
    this.data = args
  }

  /**
   * 实现 带状态表格
   * 将返回值 加入行的CLASS
   * @param {function} fn 钩子函数
   */
  tableRowClassName(fn) {
    this._tableRowClassName = fn
  }

  checkedChange(fn) {
    this._checkedChange = fn
  }

  bindButton(events) {
    this.unit.click(e => {
      const btn = $(e.target).closest('button')
    })
  }

  transColumn(field, fn) {
    this._transColumn[field] = fn
  }

  bindEvents(object) {
    this._events = object
  }

  set data(value) {
    if ($.type(value) === 'object') {
      const { rows, paginate } = value
      this.data = rows || []
    } else if ($.type(value) === 'array') {
      this._length = value.length
      this.settings.data = value
      this.update()
    }
  }

  get data() {
    return this.settings.data
  }

  set loading(key) {
    this._loading = key
    if (key) {
      // $(anthor).addClass('loading-parent--relative')
      this.unit.addClass('loading-parent--relative')
      const proxy = this.unit.find('.table__column-resize-proxy')
      proxy.after(this.mask)
      // $(anthor).append(this.mask)
    } else {
      this.unit.removeClass('loading-parent--relative')
      this.mask.detach()
    }
  }

  get loading() {
    return this._loading
  }
}
